/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobierz historia_obiektow
   * @method
   * @name Api#getHistoriaObiektow
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.warstwa_id - Id warstwy
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.filter - Treść filtra zaawansowanego
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getHistoriaObiektow = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/historia_obiektow',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['warstwa_id'] !== undefined) {
      queryParameters['warstwa_id'] = parameters['warstwa_id'];
    }

    if (parameters['warstwa_id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: warstwa_id'));
      return deferred.promise;
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined) {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['filter'] !== undefined) {
      queryParameters['filter'] = parameters['filter'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz zmiana_obiektu
   * @method
   * @name Api#getHistoriaObiektowById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getHistoriaObiektowById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/historia_obiektow/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
